import {
  updatesCtrl
} from '../admin/modals';
import {
  TerminalCommandModal
} from '../admin/terminal-command-modal.component';
import {
  DebugInfoModal
} from '../admin/debug-info-modal.component';
import ExcellentExport from 'excellentexport';
import {
  DEFAULT_STAT_LIMIT
} from '../common/config';

require('./header.component.scss');

class HeaderController {
  constructor(
    $scope,
    $element,
    $window,
    $timeout,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    $cookies,
    $modal,
    FilterEditorService,
    $http,
    CurrentFilterDataService,
    $q,
    FiltersService,
    LocalStorageService,
    FieldsModalService,
    LayoutService,
    ErrorHandlerService,
    AggregateDataService,
    TreeService,
    $templateCache,
    AdminModalService,
    SpecialModalService,
    ReportsSettingsModalService,
    FilterResource,
    PlanEditorModalService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.FilterResource = FilterResource;
    this.LayoutService = LayoutService;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.AdminModalService = AdminModalService;
    this.AggregateDataService = AggregateDataService;
    this.PlanEditorModalService = PlanEditorModalService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.langClasses = {
      'ru': 'flag-icon-ru',
      'en': 'flag-icon-gb',
      'cn': 'flag-icon-cn',
    };
    this.selectedLang = $cookies.get('django_language') || PermissionService.selectedLang || PermissionService.defaultLang;
    this.$modal = $modal;
    this.$cookies = $cookies;
    this.FilterEditorService = FilterEditorService;
    this.$http = $http;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.$q = $q;
    this.FiltersService = FiltersService;
    this.CurrentFilterService = CurrentFilterService;
    this.localStorage = LocalStorageService;
    this.FieldsModalService = FieldsModalService;
    this.TreeService = TreeService;
    this.lensePanel = this.$element.find('.lens-panel')[0];
    this.$isShowPanelWords = true;
    this.userNameWaxWidth = 'unset';
    this.$templateCache = $templateCache;
    this.SpecialModalService = SpecialModalService;
    this.ReportsSettingsModalService = ReportsSettingsModalService;

    this.$scope.$watch('$ctrl.filter.isChanged', () =>
      this.$timeout(() => this.setUserNameWaxWidth(), 10)
    );

    this.theme = $cookies.get('theme') || 'light';
    this.themes = {
      'light': gettext('Light theme'),
      'old': gettext('Old theme'),
      'dark': gettext('Dark theme'),
    };

    this.$rootScope.$on('splitter1Changed', (e, d, d2, name) => {
      this.moveTab();
      this.setUserNameWaxWidth();
    });

    this.$scope.$on('init', e => {
      this.updateMenu();
      this.setUserNameWaxWidth();
    });
  }

  get dropdownStyle() {

    return {
      'overflow': 'auto',
      'max-height': `${this.$element.parent().height() - 100}px`,
    };
  }

  updateMenu() {
    const aList = this.$window.document.querySelectorAll('.sorted-menu-item');
    aList.forEach(a => a.search = this.localStorage.getItem(a.pathname, ''));
  }

  get renderUrl() {
    const search = window.location.search + window.location.hash.substring(3);
    let url = `/render/html/${search}${search?'&':'?'}backend=${this.permission.getBackend()}`;
    if (this.currentFilter.filter.isCardFilter && url.indexOf('contentType=dimensioncardfilter') === -1) {
      url = `${url}&contentType=dimensioncardfilter`;
    }
    return url;
  }

  htmlReport() {
    this.backendReport(this.renderUrl);
  }

  pdfReport() {
    const hash = window.location.hash.replace('#!/', '');
    const url = `/analytics/filter/pdf${hash?hash + '&':'?'}pdf=${this.permission.selectedLang}`;
    this.backendReport(url);
  }

  backendReport(url) {
    this.FilterResource.sendHash(url)
      .then(src => {
        if (src) window.open(src);
        else window.open(url);
      })
      .catch(err => {
        console.error(err);
        window.open(url);
      });
  }

  downloadToExcel() {
    const url = `${this.renderUrl}&is_xls=true`;
    this.FilterResource.sendHash(url)
      .then(src => {
        if (src) this.getExcelData(src);
        else this.getExcelData(url);
      })
      .catch(err => {
        console.error(err);
        this.getExcelData(url);
      });
  }

  getExcelData(url) {
    this.CurrentFilterDataService.filterData.loading = true;
    this.$http.post(url, {}, {
      headers: {
        'Accept': 'application/json;charset=utf-8',
        'X-CSRFToken': this.$cookies.get('csrftoken'),
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(result => {
      const el = this.$element.find('#ExcelDownloadItem')[0];
      const textToBLOB = new Blob([result.data], {
        type: 'text/plain'
      });
      const sFileName = `${this.CurrentFilterService.filter.name}.xls`;
      el.download = sFileName;
      if (window.webkitURL != null) {
        el.href = window.webkitURL.createObjectURL(textToBLOB);
      } else {
        el.href = window.URL.createObjectURL(textToBLOB);
      }
      el.click();
      this.CurrentFilterDataService.filterData.loading = false;
    }, err => {
      this.CurrentFilterDataService.filterData.loading = false;
      this.ErrorHandlerService.showErrorMessageBox(
        gettext('Ошибка') + `: ${err.status} ${err.statusText}`,
        err.data,
        err.config, true
      );
    });
  }

  get isLoading() {
    return this.CurrentFilterDataService.filterData.loading;
  }

  get errorText() {
    return this.ErrorHandlerService.filterErrorMessage && this.ErrorHandlerService.filterErrorMessage.text;
  }


  link() {
    alert(this.$templateCache.get('panel_menu.html'));
  }

  get isUserNameWaxWidth() {
    return this.userNameWaxWidth > 25;
  }

  setUserNameWaxWidth() {
    if (!this.adminMenuWidth) {
      this.adminMenuWidth = this.$element.find('.admin-menu').width() -
        (this.$element.find('.lense-admin-width') ? this.$element.find('.lense-admin-width').width() : 0);
    }

    if (this.$isShowPanelWords) {
      let w = 0;
      this.$element.find('.lense-width').each(function() {
        w += this.offsetWidth;
      });
      this.lenseWidth = w;
    }
    const d = 12;
    const spaceWidth = this.lensePanel.offsetWidth - this.lenseWidth - this.adminMenuWidth;
    this.$isShowPanelWords = spaceWidth > d;
    if (this.$isShowPanelWords) {
      this.userNameWaxWidth = (spaceWidth - d);
    }
  }

  get adminTitle() {
    return gettext('Меню') + (this.permission.userName ? ` (${
      this.permission.userName[0].toUpperCase()}${this.permission.userName.substring(1)})` : '');
  }

  get isShowPanelWords() {
    return this.$isShowPanelWords;
  }

  openOptions() {
    this.LayoutService.openOptions();
  }

  get isCardOrDashboard() {
    return this.filter.isDashboard || this.filter.isCard;
  }

  nop(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  openNewDataWindow() {
    this.FieldsModalService.open('CSV');
  }

  moveTab() {
    let left = $('sc-view').offset().left;
    const winWidth = $(window).width();
    const max_left = 580;
    if (left < max_left) left = max_left;
    $('.lens-panel').css({
      'left': left
    });
    const showScreenPanel = $('.show-screen-panel');
    showScreenPanel.css({
      'right': winWidth - left + 60
    });


    if ($('sc-view').width() < 1100)
      $('.lens-panel .hideable').hide();
    else
      $('.lens-panel .hideable').show();
  }

  openNewWindow() {
    this.router.openNewWindow();
    const urlArr = this.router.search().frameUrl.split('/');
    if (urlArr[0] === 'remote' || urlArr[1] === 'remote') {
      this.router.mode = 'explore';
    }
  }

  downloadZip() {
    const filterUrl = this.CurrentFilterService.filter.url;
    this.CurrentFilterService.filter.url = '/analytics/download/zip/';
    this.zipUrl = this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
    this.CurrentFilterService.filter.url = filterUrl;
  }

  downloadDesktopVideo() {
    const filterUrl = this.CurrentFilterService.filter.url;
    this.CurrentFilterService.filter.url = '/analytics/download/desktop_videos/';
    this.videoUrl = this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
    this.CurrentFilterService.filter.url = filterUrl;
  }

  get isFilterChanged() {
    return this.currentFilter.filter ? this.currentFilter.filter.isChanged : false;
  }

  printContainer() {
    this.LayoutService.printContainer(this.CurrentFilterDataService.filterData.filterData);
  }

  saveAsPicture() {
    this.LayoutService.saveAsPicture(this.CurrentFilterDataService.filterData.filterData,
      message => {
        this.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка при получении изображения'), message, null, true);
      });
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  reset() {
    this.router.resetFilter();
  }

  debugInfo() {
    this.AdminModalService.debugInfo();
  }


  terminalCommand(terminalCommandValue, commandText) {
    this.AdminModalService.terminalCommand(terminalCommandValue, commandText);
  }

  saveFilter(asNew) {
    this.FilterEditorService.saveFilter(asNew);
  }

  editFilter() {
    if (this.CurrentFilterService.filter.isCardFilter) return;
    const filter = this.CurrentFilterService.filter.id &&
      this.CurrentFilterService.filter.isAnalyticPolitic ?
      this.FiltersService.findById(this.CurrentFilterService.filter.id) : this.CurrentFilterService.filter;
    this.FilterEditorService.editModal({
      filter: filter,
      asNew: !filter.id,
      selectFilter: true,
    });
  }

  editPlanes() {
    this.PlanEditorModalService.open({});
  }

  updateServer() {
    this.$modal.open({
        templateUrl: 'updatesDialog.html',
        controller: updatesCtrl,
      })
      .result
      .then(result => {})
      .catch((err) => {
        console.error(err);
      });
  }

  selectLang(lang) {
    if (lang !== this.$cookies.get('django_language')) {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 100);
      this.$cookies.put('django_language', lang, {
        expires: expires
      });
      location.reload();
    }
  }

  selectTheme(theme) {
    if (theme !== this.$cookies.get('theme')) {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 100);
      this.$cookies.put('theme', theme, {
        expires: expires
      });
      location.reload();
    }
  }

  newFilter(type) {
    this.router.isEditDasboard = false;
    if (type === 'deletepolicy') {
      this.SpecialModalService.createDeletePolicy(() => this.router.newFilter(type));
    } else this.router.newFilter(type);
  }

  viewReport() {
    this.router.panel = 'catalog';
    this.$rootScope.$broadcast('resize');
  }

  getEventsLink() {
    const timeFrom = this.CurrentFilterService.getTimeFrom();
    const timeTo = this.CurrentFilterService.getTimeTo();
    return '/analytics/get_events?time_from=' + timeFrom + '&time_to=' + timeTo;
  }

  getEventsFileName() {
    return 'Events.zip';
  }

  get isIncident() {
    return this.permission.admin || (this.permission.incident && ['add_incident', 'change_incident', 'delete_incident'].some(
      k => this.permission.incident[k]
    ));
  }

  get isDownloadToExcel() {
    if (!this.filter || !this.currentFilter) return false;
    return ((this.filter.mode === 'stat' ||
          (this.filter.isExplore && this.filter.listType === 'table' && this.permission.fact)) &&
        !this.currentFilter.frameUrl && this.filter.content_type == 'filter') ||
      (this.filter.mode === 'reports' && this.hasGridId) || this.filter.isCardOrDashboard;
  }

  get hasGridId() {
    const iframe = document.getElementById('iframe');
    const table = iframe ? iframe.contentDocument.getElementById('grid') : null;
    const disable_xls = iframe ? iframe.contentWindow.disable_xls_downloading : false;
    return !!table && !disable_xls;
  }

  // "agent_account@user_name:user_name"
  getIsAgent(exect) {
    let AGENTDIM = 'agent_agent@';
    let USERDIM = 'agent_account@';
    let USERFULLDIM = 'agent_account@';
    if (exect) {
      AGENTDIM = 'agent_agent@computer_name:computer_name';
      USERDIM = 'agent_account@user_name:user_name';
      USERFULLDIM = 'agent_account@full_name:full_name';
    }
    const res = (
        this.filterBar.drilldown[0].indexOf(AGENTDIM) !== -1 ||
        this.filterBar.drilldown[0].indexOf(USERDIM) !== -1 ||
        this.filterBar.drilldown[0].indexOf(USERFULLDIM) !== -1
      ) && this.currentFilter.filter &&
      this.currentFilter.filter.filters &&
      this.currentFilter.filter.filters.some(f => (
        f.dimension.indexOf(AGENTDIM) !== -1 ||
        f.dimension.indexOf(USERDIM) !== -1 ||
        f.dimension.indexOf(USERFULLDIM) !== -1
      ));
    if (!res && !exect && this.currentFilter && this.currentFilter.lastScreenshots) {
      this.stopScreenView();
    }
    return res;
  }

  stopScreenView() {
    this.router.cleanRemoteUsers();
    window.CACHE.reset();
    this.$rootScope.$broadcast('reload');
  }

  connectRemoteUsers() {
    this.AggregateDataService.loadRemoteUsers().then(resp => {
      this.AggregateDataService.allRemoteUsers = resp.data;
      this.AggregateDataService.updateRemoteUsers();
      if (!this.AggregateDataService.remoteUsers || !this.AggregateDataService.remoteUsers.length) {
        this.ErrorHandlerService.showErrorMessageBox(
          gettext('Ошибка'),
          gettext('Не удалось установить связь c агентами'),
          null, true
        );
      } else this.router.setRemoteUsers();
    });
  }

  get isScreenViewSelected() {
    return this.router.isRemoteUsers || this.router.isLastScreenshots;
  }

  openTerminal() {
    this.SpecialModalService.openTerminal();
  }

  openReportsSettings() {
    this.ReportsSettingsModalService.open();
  }


}

export const HeaderComponent = {
  template: require('./header.component.html'),
  controller: HeaderController,
};



// WEBPACK FOOTER //
// ./src/layout/header.component.js